import { useLocales } from '@shared/locales'
import { Badge, Button, Flex, Popover, Typography } from 'antd'

import { useTheme } from 'antd-style'
import { Sort } from 'iconsax-react'

import type { PopoverProps } from 'antd'

const { Title } = Typography

type Props = {
  filterActiveCount?: number
  onResetMoreFilters?: () => void
} & PopoverProps

export const MoreFiltersPopover = ({
  filterActiveCount,
  children,
  onResetMoreFilters,
  ...props
}: Props) => {
  const { t } = useLocales()
  const { colorPrimary } = useTheme()

  return (
    <Popover
      content={
        <Flex vertical gap={16}>
          {children}
        </Flex>
      }
      title={
        <Flex justify="space-between" align="center">
          <Title className="mb-0" level={5}>
            {t('filters')}
          </Title>

          {onResetMoreFilters && (
            <Button onClick={onResetMoreFilters}>{t('reset')}</Button>
          )}
        </Flex>
      }
      trigger="click"
      placement="bottomRight"
      {...props}
    >
      <Badge color={colorPrimary} count={filterActiveCount}>
        <Button icon={<Sort size={16} />}>{t('more_filters')}</Button>
      </Badge>
    </Popover>
  )
}
